<template>
  <div class="w-full flex items-center flex-col p-24 gap-16">
    <Hourglass />
    <div class="flex flex-col gap-8 items-center">
      <div class="flex items-center">
        <p
          class="font-bold text-xs uppercase bg-yellow-100 px-8 py-4 rounded-sm"
        >
          {{ $t('health_actions.scheduling.appointment_requested_title') }}
        </p>
      </div>
      <TypographyBody>
        {{ $t('health_actions.scheduling.appointment_requested_description') }}
      </TypographyBody>
    </div>
  </div>
</template>

<script>
import TypographyBody from '~/components/common/Typography/Body.vue'
import { Hourglass } from '~/assets/svgs'

export default {
  components: {
    TypographyBody,
    Hourglass,
  },
}
</script>
